import { render, staticRenderFns } from "./ManageResourceRequest.vue?vue&type=template&id=51843b3f"
import script from "./ManageResourceRequest.vue?vue&type=script&lang=js"
export * from "./ManageResourceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports